import * as PropTypes from 'prop-types';
import * as React from 'react';
import PriceFieldWithCurrency from '../shared/price_field_with_currency';

const EVERYWHERE_ELSE_CODE = 'XX';

class ShippingRate extends React.Component {
  constructor(props) {
    super(props);

    this.onRemoveShippingRate = this.onRemoveShippingRate.bind(this);
  }

  onRemoveShippingRate() {
    this.props.onRemoveShippingRate(this.props.shippingRate);
  }

  renderShippingRegionName() {
    if (this.props.shippingRate.regionCode === EVERYWHERE_ELSE_CODE) {
      return (
        <div>
          {I18n.t('shippingRates.everywhereElse')}
          <div className="size-80 opacity-80 width-70 mobile-size-70 tablet-width-100">
            {I18n.t('shippingRates.everywhereElseTip')}
          </div>
        </div>
      );
    }

    return <span>{this.props.shippingRate.regionName}</span>;
  }

  renderRequireFlag() {
    if (!this.props.shippingRate.isRequired) { return null; }

    return (
      <span className="opacity-70 d-block">
        {I18n.t('shippingRates.rateFields.required')}
      </span>
    );
  }

  renderRemove() {
    if (this.props.shippingRate.isRequired) return null;

    return (
      <button
        className="button-as-link size-70 pt-2"
        onClick={this.onRemoveShippingRate}
      >
        {I18n.t('shippingRates.rateFields.removeRate')}
      </button>
    );
  }

  renderBaseRateField() {
    return (
      <div className="shipping-rate-label-pair">
        <label>
          {I18n.t('shippingRates.rateFields.standardRate')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.shippingRate.rate.currency}
          required
          name={`${this.props.fieldsPrefix}[shipping][rates][][rate]`}
          defaultValue={this.props.shippingRate.rate.amount}
        />
      </div>
    );
  }

  renderExpeditedRateField() {
    if (!this.props.showExpeditedFields) {
      return null;
    }

    if (!this.props.shippingRate.isRequired) {
      return null;
    }

    return (
      <div className="shipping-rate-label-pair">
        <label>
          {I18n.t('shippingRates.rateFields.expeditedRate')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.shippingRate.expeditedRate.currency}
          required
          name={`${this.props.fieldsPrefix}[shipping][rates][][expedited_rate]`}
          defaultValue={this.props.shippingRate.expeditedRate.amount}
        />
      </div>
    );
  }

  renderIncrementalRateField() {
    if (!this.props.showIncrementalFields) {
      return null;
    }

    return (
      <div className="shipping-rate-label-pair">
        <label>
          {I18n.t('shippingRates.rateFields.incrementalRate')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.shippingRate.incrementalRate.currency}
          required
          name={`${this.props.fieldsPrefix}[shipping][rates][][incremental_rate]`}
          defaultValue={this.props.shippingRate.incrementalRate.amount}
        />
      </div>
    );
  }

  renderFreeShippingThresholdField() {
    if (!this.props.showFreeShippingThresholdFields) {
      return null;
    }

    return (
      <div className="shipping-rate-label-pair">
        <label>
          {I18n.t('shippingRates.rateFields.freeShippingThreshold')}
        </label>
        <PriceFieldWithCurrency
          currency={this.props.shippingRate.freeShippingThreshold.currency}
          name={`${this.props.fieldsPrefix}[shipping][rates][][free_shipping_threshold]`}
          defaultValue={this.props.shippingRate.freeShippingThreshold.amount}
        />
      </div>
    );
  }

  render() {
    return (
      <tr>
        <td className="shipping-rate-location">
          {this.renderShippingRegionName()}
        </td>
        <td>
          <input
            type="hidden"
            name={`${this.props.fieldsPrefix}[shipping][rates][][region_type]`}
            value={this.props.shippingRate.regionType}
          />
          <input
            type="hidden"
            name={`${this.props.fieldsPrefix}[shipping][rates][][region_code]`}
            value={this.props.shippingRate.regionCode}
          />
          {this.renderBaseRateField()}
          {this.renderExpeditedRateField()}
          {this.renderIncrementalRateField()}
          {this.renderFreeShippingThresholdField()}
        </td>
        <td className="shipping-rate-action align-center" data-remove-rate>
          {this.renderRemove()}
        </td>
      </tr>
    );
  }
}

ShippingRate.propTypes = {
  fieldsPrefix: PropTypes.string.isRequired,
  showExpeditedFields: PropTypes.bool.isRequired,
  showIncrementalFields: PropTypes.bool.isRequired,
  showFreeShippingThresholdFields: PropTypes.bool.isRequired,
  shippingRate: PropTypes.object,
  onRemoveShippingRate: PropTypes.func.isRequired,
};

export default ShippingRate;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_rates/shipping_rate.jsx